/**
 * Defines the types of operations that can be performed in an API call.
 */
export enum OperationType {
  /**
   * Represents an add operation.
   */
  add = 1,

  /**
   * Represents an update operation.
   */
  update = 0,

  /**
   * Represents a delete operation.
   */
  delete = -1,

  /**
   * Represents a data refresh operation, typically used to synchronize or update all data
   */
  dataRefresh = 2
}

/**
 * Represents an API operation with associated data and operation type.
 * @template T The type of the data being operated on.
 */
export interface ApiOperation<T> {

  id?: string | null;

  /**
   * The data associated with the operation.
   */
  data: T | null;

  /**
   * The type of operation to perform.
   */
  operation: OperationType;
}

